import 'babel-polyfill';
require('./components/chart');
